import React from 'react';
import { colors } from './constants';
import { XIcon, ClipboardIcon } from './Icons';

const BedHistoryModal = ({ show, onClose, bedHistory }) => {
  if (!show) return null;

  const styles = {
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      backdropFilter: 'blur(4px)'
    },
    modal: {
      background: colors.cream100,
      borderRadius: '12px',
      width: '90%',
      maxWidth: '700px',
      maxHeight: '85vh',
      overflow: 'auto',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)'
    },
    modalHeader: {
      padding: '24px',
      borderBottom: `1px solid rgba(94, 82, 64, 0.12)`,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'sticky',
      top: 0,
      background: colors.cream100,
      zIndex: 1
    },
    modalTitle: {
      fontSize: '18px',
      fontWeight: 550,
      color: colors.slate900,
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    },
    closeButton: {
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '8px',
      display: 'flex',
      alignItems: 'center',
      color: colors.slate500,
      borderRadius: '6px',
      transition: 'all 0.2s ease'
    },
    modalBody: {
      padding: '24px'
    },
    historyItem: {
      background: colors.cream50,
      border: `1px solid rgba(94, 82, 64, 0.12)`,
      borderRadius: '8px',
      padding: '16px',
      marginBottom: '12px'
    },
    historyHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '12px'
    },
    historyTitle: {
      fontSize: '14px',
      fontWeight: 600,
      color: colors.slate900
    },
    historyDate: {
      fontSize: '12px',
      color: colors.slate500
    },
    historyDetails: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '8px',
      fontSize: '13px'
    },
    detailLabel: {
      color: colors.slate500
    },
    detailValue: {
      fontWeight: 500,
      color: colors.slate900
    },
    emptyState: {
      textAlign: 'center',
      padding: '48px 24px',
      color: colors.slate500
    }
  };

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.modalHeader}>
          <h2 style={styles.modalTitle}>
            <ClipboardIcon />
            Discharge History
          </h2>
          <button 
            style={styles.closeButton}
            onClick={onClose}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(94, 82, 64, 0.12)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'none';
            }}
          >
            <XIcon />
          </button>
        </div>

        <div style={styles.modalBody}>
          {bedHistory.length === 0 ? (
            <div style={styles.emptyState}>
              {/* <ClipboardIcon /> */}
              <p>No discharge records yet</p>
            </div>
          ) : (
            bedHistory.map((record, index) => (
              <div key={index} style={styles.historyItem}>
                <div style={styles.historyHeader}>
                  <div style={styles.historyTitle}>
                    Bed {record.bedId} - {record.patient}
                  </div>
                  <div style={styles.historyDate}>
                    {record.dischargeDate}
                  </div>
                </div>
                <div style={styles.historyDetails}>
                  <div>
                    <span style={styles.detailLabel}>Doctor:</span>{' '}
                    <span style={styles.detailValue}>{record.doctor}</span>
                  </div>
                  <div>
                    <span style={styles.detailLabel}>Duration:</span>{' '}
                    <span style={styles.detailValue}>{record.duration} days</span>
                  </div>
                  <div>
                    <span style={styles.detailLabel}>Admission:</span>{' '}
                    <span style={styles.detailValue}>{record.admissionDate}</span>
                  </div>
                  <div>
                    <span style={styles.detailLabel}>Discharge:</span>{' '}
                    <span style={styles.detailValue}>{record.dischargeDate}</span>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default BedHistoryModal;
